import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const userInfo = useSelector((state) => state.login.value);
  const isUserAuthenticated = userInfo?.UserID && userInfo?.UserName;

  if (isUserAuthenticated) {
    return children;
  } else {
    return <Navigate to="/Login" />;
  }
}
